// Libraries

// Layouts

// Components
import { Table, Popup, RoleVerificationForm, Checkers } from '../../components';

// Constants
import {
    INPROCESS,
    APPROVED,
    REJECTED,
} from '../../components/Table/table.constants';
import { STATUS_MAP } from '../../utils/constants/commonValues';

import { fetchRoleCheckerRequest } from './redux/roleVerification.actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import React, { useMemo, useState, useCallback, useEffect } from 'react';

// Styles
import './roleVerification.scss';

const RoleVerificationActions = ({
    data,
    roleStatus,
    fetchData,
    resetPage,
}) => {
    const [showFilter, setShowFilter] = useState(false);
    const [actionType, setActionType] = useState(null);
    const handleOpenActionPopup = actionType => {
        setShowFilter(true);
        setActionType(actionType);
    };

    const handleCloseOpenActionPopup = isFetch => {
        setShowFilter(false);
        setActionType(null);
        if (isFetch && !isFetch.target) {
            fetchData({
                pageIndex: 1,
                pageSize: 10,
                roleStatus,
            });
            resetPage();
        }
    };
    return (
        <div className="userAction  multiItem">
            <button className="settings" onClick={handleOpenActionPopup} />
            <Popup
                title={data.original.roleName}
                actionType={actionType}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                data={data.original}
                closePopup={handleCloseOpenActionPopup}
            >
                <RoleVerificationForm
                    actionType={actionType}
                    roleStatus={roleStatus}
                    data={data.original}
                    handleOpenActionPopup={handleOpenActionPopup}
                    closePopup={handleCloseOpenActionPopup}
                />
            </Popup>
        </div>
    );
};

const RoleVerification = props => {
    const {
        roleVerificationData,
        actions,
        loader: { showLoader },
    } = props;

    const { error, tableData, isLoading, pagination } = roleVerificationData;

    const columns = useMemo(
        () => [
            { header: 'Role name', accessor: 'roleName' },
            { header: 'Date', accessor: 'roleCreatedDate' },
            { header: 'Request User', accessor: 'roleCreatedUpdate' },
            { header: 'Request Type', accessor: 'lastActions' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const pageSizeOptions = [10, 20, 40, 60];

    // We'll start our table without any data
    const [pageCount, setPageCount] = useState(0);
    const [roleStatus, setRoleStatus] = useState(INPROCESS);
    const [isResetPage, setIsResetPage] = useState(false);
    const [pageSize, setPageSize] = useState(10);

    const fetchData = useCallback(
        ({ pageSize, pageIndex, roleStatus }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,

            const request = {
                resultPerPage: pageSize,
                page: pageIndex,
                status: STATUS_MAP[roleStatus],
            };
            actions.fetchRoleCheckerRequest(request);
            setPageSize(pageSize);
        },
        [actions]
    );

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    return (
        <div className="role-verification-wrapper">
            <Table
                tableTitle="Role Verification"
                filterActionTitle=""
                isFiltersEnable
                columns={columns}
                isPaginationEnable
                tableHead={
                    <Checkers
                        checkerList={[INPROCESS, APPROVED, REJECTED]}
                        setRoleStatus={setRoleStatus}
                        roleStatus={roleStatus}
                        setIsResetPage={setIsResetPage}
                        isResetPage={isResetPage}
                        numberOfRecord={pagination.totalNumberOfRecords}
                    />
                }
                data={tableData}
                error={error && error.errorMessage}
                loading={showLoader || isLoading}
                roleStatus={roleStatus}
                pageCount={pageCount}
                fetchData={fetchData}
                numberOfRecord={pagination.totalNumberOfRecords}
                pageSizeOptions={pageSizeOptions}
                paginationLabel="Rows per page"
                setRoleStatus={role => {
                    setRoleStatus(role);
                    setIsResetPage(true);
                }}
                pagePerView={3}
                isResetPage={isResetPage}
                afterResetPage={() => setIsResetPage(false)}
                userActions={data => (
                    <RoleVerificationActions
                        data={data}
                        roleStatus={roleStatus}
                        fetchData={fetchData}
                        resetPage={() => setIsResetPage(true)}
                    />
                )}
            />
        </div>
    );
};

const mapStateToProps = ({ auth, roleVerificationData, loader }) => ({
    auth,
    roleVerificationData,
    loader,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchRoleCheckerRequest,
        },
        dispatch
    ),
});

RoleVerification.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    roleVerificationData: PropTypes.object,
    loader: PropTypes.object,
};

RoleVerificationActions.propTypes = {
    data: PropTypes.object,
    roleStatus: PropTypes.string,
    fetchData: PropTypes.func,
    resetPage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleVerification);
